import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import type { IconName } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

type DeploymentOptionCardProps = {
    icon: ReactNode;
    title: string;
    description: string;
    buttonText: string;
    buttonIcon: IconName;
    onClick: () => void;
    dataAutomation: string;
    buttonDataAutomation: string;
};

export const DeploymentOptionCard = ({
    icon,
    title,
    description,
    buttonText,
    buttonIcon,
    onClick,
    dataAutomation,
    buttonDataAutomation,
}: DeploymentOptionCardProps) => {
    const { translate } = useTranslate();
    return (
        <Stack
            flex="1"
            alignItems="center"
            justifyContent="space-between"
            padding="32px 24px"
            border={`1px solid ${colorsPalettes.carbon["50"]}`}
            borderRadius="8px"
            background={colorsPalettes.carbon["0"]}
            gap="16px"
            data-automation={dataAutomation}
        >
            <Stack
                flex="1"
                alignItems="center"
                textAlign="center"
                gap="8px"
            >
                {icon}
                <Text
                    as="strong"
                    fontVariant="subTitle3"
                    color={colorsPalettes.carbon["500"]}
                    margin="8px 0 0"
                >
                    {translate(title)}
                </Text>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon["400"]}
                >
                    {translate(description)}
                </Text>
            </Stack>
            <IconButton
                type="outlined"
                iconName={buttonIcon}
                onClick={onClick}
                data-automation={buttonDataAutomation}
            >
                {translate(buttonText)}
            </IconButton>
        </Stack>
    );
};
